import * as React from 'react';
export const getStepCurrent = (props) => {
    const { current, children } = props;
    const childCount = React.Children.count(children);
    let newCurrent = current;
    if (isNaN(current) || current < -1) {
        newCurrent = -1;
    }
    else if (current > childCount) {
        newCurrent = childCount - 1;
    }
    return newCurrent;
};
